import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ChevronRight } from "lucide-react";
import { useOnboarding } from "@/context/OnboardingContext";
import { useWordPress } from "@/context/WordPressContext";
import { useSettingsState } from "@/context/SettingsStateContext";
import useAuthentication from "@/hooks/useAuthentication";

export default function OnboardingCompletionStep() {
  const { state } = useOnboarding();
  const { handleComplete } = useAuthentication();
  const { settings: wpSettings } = useWordPress();
  const { directWpSettings } = useSettingsState();

  // Check if WordPress is already connected
  const isWordPressConnected = wpSettings?.is_connected || directWpSettings?.is_connected;

  return (
    <motion.div
      key="step-5"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{
        duration: 0.5,
        ease: "easeInOut",
        opacity: { duration: 0.3 },
      }}
      className="w-full py-4 max-w-md mx-auto text-center"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
        className="h-24 w-24 rounded-full bg-primary/10 flex items-center justify-center mb-6"
      >
        <CheckCircle2 className="h-12 w-12 text-primary" />
      </motion.div>

      <h2 className="text-3xl font-bold mb-3">Setup Complete!</h2>

      <p className="text-lg text-muted-foreground max-w-md mb-8">
        {isWordPressConnected
          ? "Your content is ready and WordPress is connected. Let's start creating!"
          : "Your content is saved and ready. You can connect WordPress anytime from settings."}
      </p>

      <Button onClick={handleComplete} size="lg" className="px-8">
        Go to Dashboard <ChevronRight className="ml-2 h-5 w-5" />
      </Button>
    </motion.div>
  );
}
